import {getAuthorities} from '.';
import {ROLE_COMERCIAL, ROLE_EXECUTIVO, ROLE_GERENCIAR_ENTIDADE, ROLE_INTERMEDIARIO, ROLE_PLATAFORMA, ROLE_SISTEMA,} from './enum';
import {obterEntidadeAtualLocal} from '../usuario-service';

const canEditarEntidade = entidade => {

  const entidadeAtual = obterEntidadeAtualLocal();
  const filterAuthorities = [
    ROLE_COMERCIAL,
    ROLE_SISTEMA,
    ROLE_EXECUTIVO,
    ROLE_INTERMEDIARIO,
    ROLE_PLATAFORMA,
  ];

  const hasAuthorities = ()=>{
    const {authorities, hasAuthority}= getAuthorities(filterAuthorities, ROLE_GERENCIAR_ENTIDADE)
    return authorities.length > 0 && hasAuthority
  }
  const entidadeAtualId = entidadeAtual?.id;
  const entidadeId = entidade?.id;

  return (entidadeAtualId === entidadeId) || hasAuthorities;
};

export const entidadeLocalEIgualLogada = (entidadeId) => {
  const entidadeAtual = obterEntidadeAtualLocal();
  const entidadeAtualId = entidadeAtual?.id;
  return entidadeAtualId === entidadeId;
}

export default canEditarEntidade;
